module.exports = __webpack_public_path__ + "img/model3_zh.d8ee3d6c.png";